import Common from '@/utils/common'
const service = 'crossborder-order-api'

/**
 * 商户申报订单查询(关联付款信息)
 */
export function queryMerDeclareOrder(data) {
  return Common.createRequest(service, 'query_mer_declare_order', data)
}
/**
 * 查询申报明细
 */
export function queryDeclareOrderDetails(data) {
  return Common.createRequest(service, 'query_declare_order_details', data)
}
/**
 * 商户重新上传申报明细提交
 */
export function againDeclareDetailSubmit(data) {
  return Common.createRequest(service, 'again_declare_detail_submit', data)
}
/**
 * 商户补充质料上传提交
 */
export function attachedSubmit(data) {
  return Common.createRequest(service, 'merchant_verify_file_save_list', data)
}
/**
 * 查询商户申报的附件列表
 */
export function queryMerVerifyFileList(data) {
  return Common.createRequest(service, 'query_mer_declare_all', data)
}

/**
 * 下载商户申报材料
 */
export function downloadDeclareFile(data) {
  return Common.createDownRequest(service, 'mer_declare_data_download', data)
}
/**
 * 下载还原文件（重新申报下载）
 */
export function declarationFileDownload(data) {
  return Common.createDownRequest(service, 'declaration_file_download', data)
}

export function declarationFileDownloadAsync(data) {
  return Common.createRequest(service, 'DECLARATION_FILE_ASYNC_QUERY_UPLOAD', data)
}
